module.exports = __webpack_public_path__ + "img/report.a17f3bb5.jpg";